export default __webpack_public_path__ + "static/media/suggestion-chips-lex1.7ee525bc.png";